// Breakpoints in pixels pulled from media-queries.scss
export const breakpoints = {
    mobileSmall: 376,
    landscape: 600,
    tablet: 768,
    laptop: 992,
    tabletLandscape: 1024,
    desktop: 1024,
    desktopWide: 1440,
}
